import { createContext, useContext } from 'react';
import { ETransactionDictionaryItemTypes, IDictionary } from 'models/dictionary';

export interface IDictionaryContext {
  gender: IDictionary[] | null;
  getGender: () => void;
  getOrganisationStateType: () => void;
  organisationStateType: IDictionary[] | null;
  getOrganisationCivilianType: () => void;
  organisationCivilianType: IDictionary[] | null;
  getOrganisationMilitaryType: () => void;
  organisationMilitaryType: IDictionary[] | null;
  getOrganisationPoliceType: () => void;
  organisationPoliceType: IDictionary[] | null;
  organisationCategory: IDictionary[] | null;
  getOrganisationCategory: () => void;
  legalVisibility: IDictionary[] | null;
  getLegalVisibility: () => void;
  legalEntityPrefix: IDictionary[] | null;
  getLegalEntityPrefix: () => void;
  civilianPrefix: IDictionary[] | null;
  getCivilianPrefix: () => void;
  militaryPrefix: IDictionary[] | null;
  getMilitaryPrefix: () => void;
  policePrefix: IDictionary[] | null;
  getPolicePrefix: () => void;
  make: IDictionary[] | null;
  getMake: () => void;
  model: IDictionary[] | null;
  getModel: () => void;
  caliber: IDictionary[] | null;
  getCaliber: () => void;
  barrelType: IDictionary[] | null;
  getBarrelType: () => void;
  state: IDictionary[] | null;
  getState: () => void;
  region: IDictionary[] | null;
  getRegion: () => void;
  country: IDictionary[] | null;
  getCountry: () => void;
  phoneCode: IDictionary[] | null;
  getPhoneCode: () => void;
  addressType: IDictionary[] | null;
  getAddressType: () => void;
  legality: IDictionary[] | null;
  getLegality: () => void;
  manufacturer: IDictionary[] | null;
  getManufacturer: () => void;
  level: IDictionary[] | null;
  getLevel: () => void;
  firearmAction: IDictionary[] | null;
  getFirearmAction: () => void;
  firearmType: IDictionary[] | null;
  getFirearmType: () => void;
  transactionType: IDictionary[] | null;
  getTransactionType: () => void;
  manufacturerCountry: IDictionary[] | null;
  getManufacturerCountry: () => void;
  legalClassification: IDictionary[] | null;
  getLegalClassification: () => void;
  transactionInitialTypes: IDictionary[] | null;
  getTransactionInitialTypes: (itemType: ETransactionDictionaryItemTypes) => void;
  transactionMiddleTypes: IDictionary[] | null;
  getTransactionMiddleTypes: (itemType: ETransactionDictionaryItemTypes) => void;
  activity: IDictionary[] | null;
  getActivity: () => void;
  countryAll: IDictionary[] | null;
  getCountryAll: () => void;
  nationality: IDictionary[] | null;
  getNationality: () => void;
  legalType: IDictionary[] | null;
  getLegalType: () => void;

  measurement: IDictionary[] | null;
  getMeasurement: () => void;
  currency: IDictionary[] | null;
  getCurrency: () => void;

  artAncillaryOptions: IDictionary[] | null;
  artAccessoryCalibre: IDictionary[] | null;
  artAccessoryComposition: IDictionary[] | null;
  artAccessoryHostType: IDictionary[] | null;
  artAccessoryLightColour: IDictionary[] | null;
  artAccessoryMagnification: IDictionary[] | null;
  artAccessoryManufacturerFlashEliminator: IDictionary[] | null;
  artAccessoryManufacturerLaserLightModule: IDictionary[] | null;
  artAccessoryManufacturerMagazine: IDictionary[] | null;
  artAccessoryManufacturerOpticalSight: IDictionary[] | null;
  artAccessoryManufacturerSuppressor: IDictionary[] | null;
  artAccessoryReticle: IDictionary[] | null;
  artAccessoryType: IDictionary[] | null;
  artAccessoryUtility: IDictionary[] | null;
  artAccessoryProofHouse: IDictionary[] | null;
  getArtAncillaryOptions: () => void;
  getArtAccessoryCalibre: () => void;
  getArtAccessoryComposition: () => void;
  getArtAccessoryHostType: () => void;
  getArtAccessoryLightColour: () => void;
  getArtAccessoryMagnification: () => void;
  getArtAccessoryManufacturerFlashEliminator: () => void;
  getArtAccessoryManufacturerLaserLightModule: () => void;
  getArtAccessoryManufacturerMagazine: () => void;
  getArtAccessoryManufacturerOpticalSight: () => void;
  getArtAccessoryManufacturerSuppressor: () => void;
  getArtAccessoryReticle: () => void;
  getArtAccessoryType: () => void;
  getArtAccessoryUtility: () => void;
  getArtAccessoryProofHouse: () => void;

  artAmmunitionType: IDictionary[] | null;
  artAmmunitionManufacturer: IDictionary[] | null;
  artAmmunitionFactory: IDictionary[] | null;
  artAmmunitionCalibreGauge: IDictionary[] | null;
  artAmmunitionCartridgeComposition: IDictionary[] | null;
  artAmmunitionColourOfPrimerSealant: IDictionary[] | null;
  artAmmunitionProjectileShape: IDictionary[] | null;
  artAmmunitionFunctionalType: IDictionary[] | null;
  artAmmunitionShotSize: IDictionary[] | null;
  artAmmunitionMunitionType: IDictionary[] | null;
  artAmmunitionMunitionVelocity: IDictionary[] | null;
  getArtAmmunitionType: () => void;
  getArtAmmunitionManufacturer: () => void;
  getArtAmmunitionFactory: () => void;
  getArtAmmunitionCalibreGauge: () => void;
  getArtAmmunitionCartridgeComposition: () => void;
  getArtAmmunitionColourOfPrimerSealant: () => void;
  getArtAmmunitionProjectileShape: () => void;
  getArtAmmunitionFunctionalType: () => void;
  getArtAmmunitionShotSize: () => void;
  getArtAmmunitionMunitionType: () => void;
  getArtAmmunitionMunitionVelocity: () => void;

  artComponentType: IDictionary[] | null;
  artComponentManufacturer: IDictionary[] | null;
  artComponentCalibre: IDictionary[] | null;
  artComponentCapacity: IDictionary[] | null;
  artComposition: IDictionary[] | null;
  artComponentProofHouse: IDictionary[] | null;
  getArtComponentType: () => void;
  getArtComponentManufacturer: () => void;
  getArtComponentCalibre: () => void;
  getArtComponentCapacity: () => void;
  getArtComposition: () => void;
  getArtComponentProofHouse: () => void;

  auditLogModule: IDictionary[] | null;
  auditLogEventType: IDictionary[] | null;
  auditLogEventName: IDictionary[] | null;
  getAuditLogModule: () => void;
  getAuditLogEventType: () => void;
  getAuditLogEventName: () => void;

  apiKeyType: IDictionary[] | null;
  getApiKeyType: () => void;
  task: IDictionary[] | null;
  getTask: () => void;
  weaponLicenceRegion: IDictionary[] | null;
  getWeaponLicenceRegion: () => void;
  weaponLicenceCategory: IDictionary[] | null;
  getWeaponLicenceCategory: () => void;
  weaponLicencePrimaryPurpose: IDictionary[] | null;
  getWeaponLicencePrimaryPurpose: () => void;
  weaponLicenceCondition: IDictionary[] | null;
  getWeaponLicenceCondition: () => void;
  weaponLicenceCompetency: IDictionary[] | null;
  getWeaponLicenceCompetency: () => void;
  weaponLicenceLimit: IDictionary[] | null;
  getWeaponLicenceLimit: () => void;
  weaponLicenceDuration: IDictionary[] | null;
  getWeaponLicenceDuration: () => void;
  weaponLicenceFee: IDictionary[] | null;
  getWeaponLicenceFee: () => void;
  weaponLicencingAuthority: IDictionary[] | null;
  getWeaponLicencingAuthority: () => void;
  weaponLicenceGoodReason: IDictionary[] | null;
  getWeaponLicenceGoodReason: () => void;
  weaponLicencePaymentStatus: IDictionary[] | null;
  getWeaponLicencePaymentStatus: () => void;
  getWeaponLicenceStatus: () => void;
  weaponLicenceStatus: IDictionary[] | null;
  getWeaponLicenceHistoryAction: () => void;
  weaponLicenceHistoryAction: IDictionary[] | null;
  getApplicationProcessStatus: () => void;
  applicationProcessStatus: IDictionary[] | null;
  getWeaponLicenceTemplateStatus: () => void;
  weaponLicenceTemplateStatus: IDictionary[] | null;
  getWeaponLicenceCaseStatus: () => void;
  weaponLicenceCaseStatus: IDictionary[] | null;
  getWeaponLicencePrintStatus: () => void;
  weaponLicencePrintStatus: IDictionary[] | null;
  getWeaponLicencePrintBatchStatus: () => void;
  weaponLicencePrintBatchStatus: IDictionary[] | null;
  getWeaponLicencePrintType: () => void;
  weaponLicencePrintType: IDictionary[] | null;

  maritalStatus: IDictionary[] | null;
  getMaritalStatus: () => void;
  identificationDocumentType: IDictionary[] | null;
  getIdentificationDocumentType: () => void;
  attachmentDocumentTypeData: IDictionary[] | null;
  getAttachmentDocumentTypeData: () => void;
  applicationProcessTypes: IDictionary[] | null;
  getApplicationProcessTypes: () => void;
  caseProcessTypes: IDictionary[] | null;
  getCaseProcessTypes: () => void;

  getLegalStatus: () => void;
  legalStatus: IDictionary[] | null;
  getLegalIndividualDeactivationReason: () => void;
  legalIndividualDeactivationReason: IDictionary[] | null;
  getLegalOrganisationDeactivationReason: () => void;
  legalOrganisationDeactivationReason: IDictionary[] | null;
  getTaskStatus: () => void;
  taskStatus: IDictionary[] | null;
  getIntelligenceReportSourceSystem: () => void;
  intelligenceReportSourceSystem: IDictionary[] | null;
  getCaseRejectionReason: () => void;
  caseRejectionReason: IDictionary[] | null;
  getCaseApprovalReason: () => void;
  caseApprovalReason: IDictionary[] | null;
  getCaseRefusalReason: () => void;
  caseRefusalReason: IDictionary[] | null;
  getOtherRequestTaskName: () => void;
  otherRequestTaskName: IDictionary[] | null;
}

export const DictionaryContext = createContext<IDictionaryContext>({} as IDictionaryContext);

export const useDictionary = (): IDictionaryContext => useContext(DictionaryContext);
